/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxList } from "../../funcs/sandboxList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListSessionsRequest$inboundSchema,
};

export const tool$sandboxList: ToolDefinition<typeof args> = {
  name: "sandbox-list",
  description: `List Sessions

List sandbox sessions visible to the authenticated caller.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
